module.exports = __webpack_public_path__ + "img/energymeter.05be4334.png";